import type {
  UpdateOrderItemsResult,
  InsufficientStockError,
  OrderLimitError,
  NegativeQuantityError,
  OrderModificationError,
} from "../../../mutations/AddItemToOrder/AddItemToOrder.types";
import { AddToCartNormalized } from "./DeliveryCard.types";

export function normalizeResponse(
  result: UpdateOrderItemsResult
): AddToCartNormalized {
  switch (result.__typename) {
    case "Order":
      return {
        ok: true,
        type: "order",
        order: result,
      };

    case "InsufficientStockError": {
      const r = result as InsufficientStockError;
      return {
        ok: false,
        type: "insufficientStock",
        message: r.message,
        order: r.order,
      };
    }

    case "OrderLimitError": {
      const r = result as OrderLimitError;
      return {
        ok: false,
        type: "orderLimit",
        message: r.message,
      };
    }

    case "NegativeQuantityError": {
      const r = result as NegativeQuantityError;
      return {
        ok: false,
        type: "negativeQuantity",
        message: r.message,
      };
    }

    case "OrderModificationError": {
      const r = result as OrderModificationError;
      return {
        ok: false,
        type: "orderModification",
        message: r.message,
      };
    }

    default:
      return {
        ok: false,
        type: "unknown",
        message: "Unexpected error while updating the cart.",
      };
  }
}
